import * as React from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const location = useLocation();

  React.useEffect(() => {
    // Using location.key ensures scroll resets even when navigating to the same page
    window.scrollTo(0, 0);
  }, [location.key]);

  return null;
};

export default ScrollToTop;
